<template>
  <div class="text-color border-color background-color prc-item">
    <div>
      <h2 class="plateReplacementCenterTitle">
        {{ plateReplacementCenter.Title }}
      </h2>
      <h3 class="plateReplacementCenterTitle">
        {{ plateReplacementCenter.Address }}
      </h3>
    </div>
    <div>
      <hr />
      <div class="phone">
        <div class="title"><i class="fas fa-phone"></i> تلفن:</div>
        <div>
          <a :href="'tel:' + plateReplacementCenter.PhoneNumber">{{
            plateReplacementCenter.PhoneNumber
          }}</a>
        </div>
      </div>
    </div>
    <div
      class="info"
      v-if="
        plateReplacementCenter.NormalDaysStartTime &&
          plateReplacementCenter.NormalDaysEndTime &&
          plateReplacementCenter.HolidaysStartTime &&
          plateReplacementCenter.HolidaysEndTime
      "
    >
      <div>
        ساعت کاری شنبه تا پنج شنبه:
        {{ plateReplacementCenter.NormalDaysStartTime }} الی
        {{ plateReplacementCenter.NormalDaysEndTime }}
      </div>
      <div>
        ساعت کاری ایام تعطیل و جمعه:
        {{ plateReplacementCenter.HolidaysStartTime }} الی
        {{ plateReplacementCenter.HolidaysEndTime }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "plate-replacement-center-item",
  props: {
    plateReplacementCenter: { required: true },
  },
  filters: {
    call(value) {
      return `tell:${value}`;
    },
  },
};
</script>

<style>
.prc-item {
  text-align: right;
  padding: 0;
  border: solid 1px;
  margin: 7px 10px 0 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px;
  position: relative;
  text-align: center;
}
.prc-item > div {
  padding: 10px 10px 0 10px;
  text-align: right;
}
.prc-item h3 {
  margin: 15px 0 0 0;
}
.prc-item hr {
  opacity: 0.2;
  margin: 8px 0;
}
.prc-item .phone {
  display: flex;
  align-items: center;
  font-size: 17px;
  margin-bottom: 10px;
}
.prc-item .phone .title {
  flex: 1;
}
.prc-item .info {
  padding: 5px;
  line-height: 30px;
}
.prc-item .info {
  background-color: #e6e6e6;
}
.dark .prc-item .info {
  background-color: #222;
}
.prc-item i {
  color: white;
  border-radius: 50%;
  background-color: #222;
  padding: 5px;
  margin-left: 5px;
}
h2.plateReplacementCenterTitle {
  font-weight: normal;
  font-size: 16px;
}
h3.plateReplacementCenterTitle {
  font-weight: normal;
  font-size: 14px;
}
</style>
